import { PureComponent } from 'react';

import { MessageStatus } from '../messageStatus';

type StatusAbandonedProps = {};

export default class StatusAbandoned extends PureComponent<StatusAbandonedProps> {
  render() {
    const { ...otherProps } = this.props;

    return (
      <MessageStatus
        {...(otherProps as any)}
        text="Conversation was abandoned by customer"
      />
    );
  }
}
